import SelectInput from './select-input-view'
export default SelectInput
